'use client'

import it from '@/assets/images/italy-flag.svg';
import en from '@/assets/images/uk-flag.svg';
import { LocaleType, usePathname, useRouter } from '@/i18n/routing';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useLocale } from 'next-intl';

type Props = {
}

export default function LanguageSwitcher({ }: Props) {

    const pathname = usePathname();
    const searchParams = useSearchParams();
    const router = useRouter();

    const locale = useLocale();

    const switchLanguage = () => {
        let newLanguage: LocaleType;
        if (locale === 'it') {
            newLanguage = 'en'
        } else {
            newLanguage = 'it'
        }
        router.replace(pathname + '?' + searchParams, { locale: newLanguage });
    }

    // useEffect(() => {
    //     firebaseClientAuth.languageCode = locale ?? 'it';
    // }, [language]);

    return (
        <div onClick={switchLanguage}
            className="relative w-16 h-8 flex items-center bg-greyH cursor-pointer rounded-full p-1 justify-between bg-primaryBlue700">

            <Image
                src={en}
                alt={'en'}
                width={20}
                height={20}
            />
            <div className="absolute bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300"
                style={locale === 'it' ? { left: "2px" } : { right: "2px" }}

            ></div>
            <Image
                src={it}
                alt={'it'}
                width={20}
                height={20}
            />
        </div>

    );
}